import React, { useState, useEffect, useGlobal, setGlobal } from 'reactn';



import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from './components/home'
import Work from './components/work'
import About from './components/about'
import WorkSingle from './components/workSingle'
import Contact from './components/contact'
import './styles/style.scss';
import axios from 'axios';


setGlobal({
  selectedWork: ''
});
setGlobal({
  workItems: ''
});


export default function BasicExample() {
  // CHANGE THIS WITH HOME LOOP
  const [posts, setPosts] = useState([{posttt:'2'}]);
  const [pages, setPages] = useState([{posttt:'2'}]);
  const [home, setHome] = useState([{posttt:'2'}]);
  const [work, setWork] = useState([{posttt:'2'}]);
  const [about, setAbout] = useState();
  const [contact, setContact] = useState([{posttt:'2'}]);

  const GetPosts = () => {
    axios.get('http://design-mind.co.uk/design-admin/wp-json/wp/v2/work')
    .then(response => {
      console.log(response.data);
      setPosts(response.data);
      setGlobal({
        workItems: response.data
      });
    })
    .catch(error => {
      console.log(error);
    });
  }
  const GetPages = () => {
    axios.get('http://design-mind.co.uk/design-admin/wp-json/wp/v2/pages')
    .then(response => {
      console.log(response.data);
      setPages(response.data);
      let home = response.data.find(x => x.id === 2);
      let work = response.data.find(x => x.id === 24);
      let about = response.data.find(x => x.id === 29);
      let contact = response.data.find(x => x.id === 31);
      setHome(home);
      setWork(work);
      setAbout(about);
      setContact(contact);
      console.log(home)
    })
    .catch(error => {
      console.log(error);
    });
  }

  useEffect(() => {
      GetPosts();
      GetPages();
  }, []);
  
  return (
    <div className="container-fluid">
      <Router>
      <header>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      
        <div className="d-md-flex justify-content-between align-items-md-end">
          <div class="logo">
            <Link to="/"><img src={`${process.env.PUBLIC_URL}/DM_LOGO_BLACK.png`}/></Link>
          </div>
          <nav class="navbar navbar-expand d-flex">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav">
                <li className="nav-item">
                  <Link to="/work">work</Link>
                </li>
                <li className="nav-item">
                  <Link to="/about">about</Link>
                </li>
                <li className="nav-item">
                  <Link to="/contact">contact</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
      <div className="data-container">
          {/*
            A <Switch> looks through all its children <Route>
            elements and renders the first one whose path
            matches the current URL. Use a <Switch> any time
            you have multiple routes, but you want only one
            of them to render at a time
          */}
          <Switch>
            <Route exact path="/">
              <Home posts={posts} page={home}/>
            </Route>

            <Route path={`/works/:topicId`}>
              <WorkSingle  />
            </Route>
            <Route path="/work">
              <Work posts={posts} page={work}/>
            </Route>
            
            <Route path="/about">
              <About posts={posts}  page={about} />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            
          </Switch>
        </div>
      </Router>
      <section className="footer">
        <ul>
          <li>Based in The Cotswolds</li>  
          <li><a href="mailTo:hello@design-mind.co.uk">hello@design-mind.co.uk</a></li>
        </ul>
      </section>
    </div>
      
  );
}
